module.exports = __webpack_public_path__ + "static/media/flower_hero_twitter_card.ab256262.jpg";